import DOMPurify from 'dompurify';
export { capitalize } from '@demandstar/components/utils';

export function pluralize(count: number, singular: string, plural: string) {
  if (count === 1) {
    return singular;
  } else {
    return plural;
  }
}
function removeSqlKeywords(inputString) {
  const sqlKeywords = [
    'SELECT', 'INSERT', 'UPDATE', 'DELETE', 'DROP', 'ALTER', 'TRUNCATE',
    'EXEC', 'UNION', 'OR', 'AND', 'WHERE', 'FROM', 'GRANT', 'REVOKE',
    '--', 'LOAD_FILE', 'INTO OUTFILE', 'INFORMATION_SCHEMA', 'SYSTEM', 'XP_CMDSHELL','LOADFILE',  'INFORMATIONSCHEMA' , 'XPCMDSHELL','SCRIPT',
  ];

  const keywordPattern = new RegExp(`\\b(${sqlKeywords.join('|')})\\b`, 'gi');
  inputString = inputString.replace(keywordPattern, '');

  return inputString;
}


export const cleanInput = (input) => {
  let cleanedInput = input.replace(/[^a-zA-Z0-9&, ]/g, '');
  cleanedInput = cleanedInput.replace(/script/gi, '');
  cleanedInput = removeSqlKeywords(cleanedInput);
  return cleanedInput;
};

 export const sanitizeHTML = (html: string) =>{
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: [
      'script','iframe','object','embed','form','input','button','select','textarea','img',
    ],

    FORBID_ATTR: [
      'onclick','onerror','onload','onmouseover','onfocus','onblur','onchange','onsubmit','href','src',
    ],
  })|| 'None';};
